import { arrayOrObjectToCamelCase } from 'helpers'

export const WGCWX_LEADERBOARDS_REQUEST = 'wgcwx_leaderboards/REQUEST'
export const WGCWX_LEADERBOARDS_SUCCESS = 'wgcwx_leaderboards/SUCCESS'
export const WGCWX_LEADERBOARDS_ERROR = 'wgcwx_leaderboards/ERROR'

export const WGCWX_LEADERBOARDS_GET_REWARDS_REQUEST = 'wgcwx_leaderboards/GET_REWARDS_REQUEST'
export const WGCWX_LEADERBOARDS_GET_REWARDS_SUCCESS = 'wgcwx_leaderboards/GET_REWARDS_SUCCESS'
export const WGCWX_LEADERBOARDS_GET_REWARDS_ERROR = 'wgcwx_leaderboards/GET_REWARDS_ERROR'

export function requestLeaderboards() {
    return async (dispatch, getState) => {
        const { settings } = getState()

        dispatch({ type: WGCWX_LEADERBOARDS_REQUEST })
        try {
            const url = `${settings.gatewayHost}/global_map/wgapi/leaderboards/`
            const response = await fetch(url, { credentials: 'include' })
                .then(r => {
                    return r.json().then(data => ({ ok: r.ok, body: data }))
                })

            if (!response.ok) {
                const err = response.body
                throw new Error(err.title || err.description)
            }

            const leaderboards = arrayOrObjectToCamelCase(response.body)

            if (!leaderboards.leaderboards.length) {
                throw new Error('Leaderboards are empty')
            }

            dispatch({
                type: WGCWX_LEADERBOARDS_SUCCESS,
                payload: {
                    leaderboards,
                },
            })
        } catch (error) {
            dispatch({
                type: WGCWX_LEADERBOARDS_ERROR,
                payload: {
                    errorMessage: error.message,
                },
            })
        }
    }
}

export function getRewards() {
    return async (dispatch, getState) => {
        const { settings } = getState()

        dispatch({ type: WGCWX_LEADERBOARDS_GET_REWARDS_REQUEST })
        try {
            const url = `${settings.gatewayHost}/global_map/wgapi/leaderboards/rewards/`

            const response = await fetch(url, {
                method: 'POST',
                credentials: 'include',
            })

            if (!response.ok) {
                const err = await response.json()
                throw new Error(err.title || err.description)
            }

            dispatch({ type: WGCWX_LEADERBOARDS_GET_REWARDS_SUCCESS })
        } catch (error) {
            dispatch({
                type: WGCWX_LEADERBOARDS_GET_REWARDS_ERROR,
                payload: {
                    errorMessage: error.message,
                },
            })
        }
    }
}



// WEBPACK FOOTER //
// ./state/actions/wgcwx_leaderboards.js